(function () {
  function markLoaded(img) {
    img.classList.add('is-loaded');
  }

  function observe(img) {
    if (img.complete) {
      markLoaded(img);
      return;
    }
    img.addEventListener('load', function () {
      markLoaded(img);
    }, { once: true });
    img.addEventListener('error', function () {
      markLoaded(img);
    }, { once: true });
  }

  function scan(root) {
    root.querySelectorAll('img[loading="lazy"]').forEach(observe);
  }

  scan(document);

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('img[loading="lazy"]')) {
            observe(node);
          }
          if (node.querySelectorAll) {
            scan(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
